import { FranjaOnceComponent } from './components/franja-once/franja-once.component';
import { AvisoNotificacionesComponent } from './components/aviso-notificaciones/aviso-notificaciones.component';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule, REMOVE_STYLES_ON_COMPONENT_DESTROY, provideClientHydration, withEventReplay, withNoHttpTransferCache, withIncrementalHydration } from '@angular/platform-browser';
import { TransferState, RendererFactory2 } from '@angular/core';
import { IonicClassSafeRendererFactory } from './ionic-class-safe-renderer';
import { ManejadorDeErrores } from './trozo-perdido';
import { RouteReuseStrategy, UrlSerializer } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClient, provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';

import { ShellModule } from './components/shell.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
import { SharedModule } from './components/shared';
import { BarraInferiorComponent } from './components/barra-inferior/barra-inferior.component';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { CustomUrlSerializer } from './services/custom-url-serializer';
import { translateBrowserLoaderFactory } from 'src/shared/loaders/translate-browser.loader';
import { CookieModule } from 'ngx-cookie';

import { TimePipe } from 'src/app/pipes/time/time.pipe';
import { ServiceWorkerModule } from '@angular/service-worker';

// Firebase se inicializa en app.component.ts cuando se necesita

// import Quill from 'quill';

// var InlineBlot = Quill.import('blots/block');
// class CustomImage extends InlineBlot {
//   static create(data) {

//     if (typeof data !== 'object') return super.create(false);

//     console.log(data);

//     const node = super.create(data);

//     node.setAttribute('src', data.src);

//     if (data.class) node.setAttribute('class', data.class);
//     if (data.width) node.setAttribute('width', data.width);
//     if (data.height) node.setAttribute('height', data.height);
//     if (data.id) node.setAttribute('id', data.id);

//     return node;
//   }

//   static value(domNode) {
//     return domNode.dataset;
//   }
// }
// // @ts-ignore
// CustomImage.blotName = 'customimage';
// // @ts-ignore
// CustomImage.className = 'img';
// // @ts-ignore
// CustomImage.tagName = 'IMG';

// Quill.register({ 'formats/customimage': CustomImage });

// if (typeof document !== 'undefined') {
//   var BlockEmbed = Quill.import('blots/embed');
//   class EmojiMichollo extends BlockEmbed {
//     static create(value) {
//       const node = super.create(value);
  
//       // console.log({ value });
  
//       try {
//         let emojiData = JSON.parse(value)
//         node.setAttribute('contentEditable', 'false');
  
//         node.setAttribute('src', emojiData.src);
//         node.setAttribute('title', emojiData.title);
//         node.setAttribute('alt', emojiData.alt);
  
//         node.setAttribute('data-emoji', value);
//         // node.classList.add(value);
//         // node.setAttribute('title', value);
//         // node.setAttribute('data-class-emoji', value);
        
//       } catch (error) {
//         console.log(error);
//       }
    
//       return node;
//     }
  
//     static value(node) {
//       // console.log(node, node.getAttribute('class'))
//       //@ts-ignore
//       // return node.getAttribute('class').replace('emoji-michollo', '').trim();
//       return node.getAttribute('data-emoji');
//     }
//   }
  
//   //@ts-ignore
//   EmojiMichollo.blotName = 'emojimichollo';
//   //@ts-ignore
//   EmojiMichollo.tagName = 'IMG';
//   //@ts-ignore
//   EmojiMichollo.className = 'emoji-michollo';
  
//   Quill.register(EmojiMichollo);
// }

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule, FranjaOnceComponent, AvisoNotificacionesComponent,
        // rippleEffect: false — evita registrar un ion-ripple-effect por cada
        // ion-button (kmh x5 por tarjeta, chollo-buttons x4, toolbar,
        // cookies-bar...); los botones nativos no lo usan. Resto de la
        // configuración por defecto (sin forzar mode).
        // useSetInputAPI: sin esto Ionic mete `componentProps` con `Object.assign`, que MACHACA
        // una entrada de señal —deja un booleano donde había una función—. El lote C5 pasó 56
        // entradas a `input()` y entre ellas iba `seller` del modal de acceso: desde entonces el
        // modal de login se creaba VACÍO y no se abría. Con esto Ionic usa `ComponentRef.setInput`,
        // que es lo que entiende de señales. A cambio exige que TODA clave de `componentProps` sea
        // una entrada declarada: lo que no lo es, se descarta en silencio en producción. Están
        // repasadas una a una (auth-modal.type, select-photo y stripe llevaban campos sueltos).
        IonicModule.forRoot({ rippleEffect: false, useSetInputAPI: true }),
        AppRoutingModule,
        // Barra inferior móvil (S12): componente independiente, se ve solo bajo 993 px.
        BarraInferiorComponent,
        // Sprite de iconos: <symbol> únicos inyectados una vez, primer hijo de
        // <ion-app> (ver app.component.html). Cada <app-icon> los referencia con
        // <use href="#mc-<slug>"> en vez de repetir el SVG completo.
        TranslateModule.forRoot({
            defaultLanguage: 'es',
            loader: {
                provide: TranslateLoader,
                useFactory: translateBrowserLoaderFactory,
                deps: [HttpClient, TransferState]
            }
        }),
        ShellModule, // Solo el cascarón eager (toolbar/cookies-bar/search/user);
        // el resto de ComponentModule ahora va en chunks lazy.
        SharedModule,
        CookieModule.withOptions(),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // NO usar 'registerImmediately'. El grupo 'app' de ngsw-config.json
            // está en installMode: prefetch y son 93 ficheros, 6,3 MB: al
            // registrarse de inmediato, el Service Worker se los descarga
            // compitiendo con el propio arranque de la aplicación y con la
            // llamada a any/:id que decide si se pinta la ficha. Esperar a que la
            // app esté estable deja el ancho de banda para lo que hace falta
            // ahora; el cacheo se hace igual, sólo que después.
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        // Ver ionic-class-safe-renderer.ts: evita que la hidratación borre las clases
        // que Stencil pone en los ion-* (hydrated/md/…) y deje la página oculta.
        { provide: RendererFactory2, useClass: IonicClassSafeRendererFactory },
        // Angular quita el <style> de un componente al destruir su última instancia y lo
        // vuelve a insertar con la siguiente: el esqueleto del feed lo hacía 295 veces por
        // sesión de scroll (12 KB parseados cada vez, audit H5). Los estilos se quedan.
        { provide: REMOVE_STYLES_ON_COMPONENT_DESTROY, useValue: false },
        // StatusBar,
        // SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // Si al navegar falta un trozo de la aplicación (despliegue nuevo, pestaña vieja),
        // recargar en vez de quedarse a medias. Ver trozo-perdido.ts.
        { provide: ErrorHandler, useClass: ManejadorDeErrores },
        TimePipe,
        { provide: UrlSerializer, useClass: CustomUrlSerializer },
        // withFetch: con withXhr() las respuestas en SERVIDOR completaban fuera de la
        // zona → sin change detection → el DOM se serializaba con el esqueleto aunque
        // el TransferState ya llevara los datos (NG02801). fetch es el default de v22.
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        // Hidratación (compartido cliente+servidor: AppServerModule importa AppModule) →
        // el servidor añade anotaciones ngh y el cliente REUTILIZA el DOM en vez de
        // re-renderizar. withEventReplay no pierde clics durante la hidratación.
        provideClientHydration(withEventReplay(),
          // Fase B: los bloques @defer (hydrate on viewport) del home hidratan
          // bajo demanda; el resto del arranque no ejecuta su JS.
          withIncrementalHydration(),
          // La app ya transfiere las respuestas API con claves manuales (rest.service,
          // 'michollo-...'): la caché HTTP automática de la hidratación duplicaba cada
          // respuesta en el TransferState (~25KB extra de HTML por página).
          withNoHttpTransferCache())
    ] })
export class AppModule {}

const stripTrailingSlash = (Location as any).stripTrailingSlash;
Location.stripTrailingSlash = (url) => {
  if (url.includes('?')) {
    url = url.replace(/\/\?|\?/, '/?');
  } else if (!url.endsWith('/')) {
    url = url + '/';
  }

  const queryString$ = url.match(/([^?]*)?(.*)/);
  if (queryString$[2].length > 0) {
    return /[^\/]\/$/.test(queryString$[1]) ? queryString$[1] + queryString$[2] : stripTrailingSlash(url);
  }
  return /[^\/]\/$/.test(url) ? url : stripTrailingSlash(url);
};
